import { formSubmitClear, formComplete } from 'actions/forms'
import { notify } from '../utils/notification'
import { parseError, agent, updateSessionObject } from 'utils/api'
import { getFiscalYearTimestamps } from 'utils/fiscalYear'
import constants from 'constants'
import { push } from 'react-router-redux'

export const PARTNERPLANRATINGVISIBILITY_GET = 'PARTNERPLANRATINGVISIBILITY_GET'
export const PARTNERPLANRATINGVISIBILITY_RECEIVED = 'PARTNERPLANRATINGVISIBILITY_RECEIVED'
export const PARTNERPLANRATINGVISIBILITY_GET_ERROR = 'PARTNERPLANRATINGVISIBILITY_GET_ERROR'
export const PARTNERPLANRATINGVISIBILITY_SAVE_REQUEST = 'PARTNERPLANRATINGVISIBILITY_SAVE_REQUEST'
export const PARTNERPLANRATINGVISIBILITY_SAVE_ERROR = 'PARTNERPLANRATINGVISIBILITY_SAVE_ERROR'
export const PARTNERPLANRATINGVISIBILITY_SAVE_COMPLETE = 'PARTNERPLANRATINGVISIBILITY_SAVE_COMPLETE'

const fetching = type => ({
  type,
})

const fetchingerror = type => ({
  type,
})

const partnerPlanRatingVisibilityReceive = ratingVisibility => ({
  type: PARTNERPLANRATINGVISIBILITY_RECEIVED,
  ratingVisibility,
})

const savePartnerPlanRatingVisibilityRequest = () => ({
  type: PARTNERPLANRATINGVISIBILITY_SAVE_REQUEST,
})

const savePartnerPlanRatingVisibilityError = errors => ({
  error: errors[0].error,
  type: PARTNERPLANRATINGVISIBILITY_SAVE_ERROR,
})

const savePartnerPlanRatingVisibilityComplete = ratingVisibility => ({
  type: PARTNERPLANRATINGVISIBILITY_SAVE_COMPLETE,
  ratingVisibility,
})

const selectedfilter = (selectedFilter, selectedFilterType) => ({
  type: selectedFilterType,
  selectedFilter,
})

export function getPartnerPlanRatingVisibility(employeeId, planYear = getFiscalYearTimestamps().current.year - constants.PARTNERPLAN.PLAN_FILTER_PARTNER_YEAR) {
  return (dispatch) => {
    dispatch(fetching(PARTNERPLANRATINGVISIBILITY_GET))
    agent.PartnerPlanAdmin.listratingvisibility(employeeId, planYear)
      .then((result) => {
        dispatch(partnerPlanRatingVisibilityReceive(result))
      })
      .catch((rawError) => {
        // console.error('getPartnerPlanOverviewPages error', rawError, rawError.stack, window.location)
        console.error('Getting partner plan rating visibility error')
        const { error, status, description } = parseError(rawError)
        if (status === constants.ERROR.INTERNAL_SERVER) {
          dispatch(push({
            pathname: '/error',
            search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
          }))
        } else if (status === constants.ERROR.UNAUTHORIZED) {
          updateSessionObject()
        } else {
          dispatch(notify(description))
          dispatch(notify('Error fetching partner plan rating visibility', 'warning'))
          dispatch(push({ pathname: '/' }))
        }
      })
  }
}

export const editPartnerPlanRatingVisibility = (payload, formId, redirect = true) => (dispatch) => {
  dispatch(savePartnerPlanRatingVisibilityRequest())
  agent.PartnerPlanAdmin.updateratingvisibility(payload).then((response) => {
    dispatch(savePartnerPlanRatingVisibilityComplete(response))
    dispatch(notify((payload.enabled ?
      `${payload.business_unit} ${payload.year} ${payload.stage} final ratings released to partners.` :
      `${payload.business_unit} ${payload.year} ${payload.stage} final ratings hidden to partners.`), 'success'))

    /* if (redirect) {
      dispatch(getPartnerPlanRatingVisibility(payload.employee_id, payload.year))
    } */
    dispatch(formComplete(formId))
  }).catch((rawError) => {
    const { error, status, description } = parseError(rawError)
    if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
      dispatch(push({
        pathname: '/error',
        search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
      }))
    } else if (status === constants.ERROR.UNAUTHORIZED) {
      updateSessionObject()
    } else {
      dispatch(notify('Error saving partner plan rating visibility, please try again later', 'warning'))
      console.warn('Err <editPartnerPlanRatingVisibility>: ', description, error)
      dispatch(formSubmitClear(formId))
    }
  })
}




// WEBPACK FOOTER //
// ./src/actions/partnerPlanRatingVisibility.js